<ng-container *ngIf="tenant === 14">
  <qm-neve-measurements-table></qm-neve-measurements-table>
</ng-container>
